/**
 * Haelt den Konfigurator-Link an der gewaehlten Variante.
 *
 * Wird nur geladen, wenn sich die Links zwischen den Varianten unterscheiden.
 * Hat eine Variante keinen Link und das Produkt auch nicht, verschwindet der
 * Einstieg, statt in einen fremden Ring zu fuehren.
 */
(function () {
  'use strict';

  function update(variantId) {
    if (!variantId) return;

    document.querySelectorAll('[data-veynou-configurator-data]').forEach(function (island) {
      if (island.veynouLinks === undefined) {
        try {
          island.veynouLinks = JSON.parse(island.textContent);
        } catch (error) {
          console.warn('[veynou-configurator] Datensatz nicht lesbar', error);
          island.veynouLinks = null;
        }
      }

      var data = island.veynouLinks;
      if (!data) return;

      var cta = island.parentNode.querySelector('[data-veynou-configurator]');
      if (!cta) return;

      var link = data.links[String(variantId)];
      if (link) {
        cta.setAttribute('href', link);
        cta.hidden = false;
      } else {
        cta.hidden = true;
      }
    });
  }

  document.addEventListener('variant:change', function (event) {
    update(event.detail && event.detail.variant && event.detail.variant.id);
  });

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS === 'object') {
    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      update(event && event.data && event.data.variant && event.data.variant.id);
    });
  }

  update(new URLSearchParams(window.location.search).get('variant'));
})();
